import { useState, useEffect } from "react";
import cn from "classnames";
import moment from "moment";
import "moment/locale/ru";
import { Pagination, Modal } from "react-bootstrap";

import { FetchService } from "../../../../API/FetchService.js";
import { FetchComponent } from "../../../FetchComponent/FetchComponent.jsx";
import { SwitchAnimation } from "../../../Animation/Animation.jsx";

import styles from "./CabinetFinance.module.css";

const FinanceItem = ({ data }) => {
  const { date, credit, description, amount } = data;
  const chooseBgColor = () => {
    return credit ? "#87f483" : "#f8adaa";
  };

  return (
    <div
      className={cn("row", styles.financeItem)}
      style={{ backgroundColor: chooseBgColor() }}
    >
      <div className="col-4 p-2">
        <div className="h-100 d-flex justify-content-center align-items-center">
          <p className="m-0 text-center">{moment(date).format("D MMM YYYY")}</p>
        </div>
      </div>
      <div className="col-4 p-2">
        <div className="h-100 d-flex justify-content-center align-items-center">
          {description ? (
            <p className="m-0 text-center">{description}</p>
          ) : (
            <div className={styles.border}></div>
          )}
        </div>
      </div>
      <div className="col-1 p-2">
        <div className="h-100 d-flex justify-content-center align-items-center">
          {credit ? (
            <i className="fa fa-plus" aria-hidden="true" />
          ) : (
            <i className="fa fa-minus" aria-hidden="true" />
          )}
        </div>
      </div>
      <div className="col-3 p-2">
        <div className="h-100 d-flex justify-content-center align-items-center">
          <p className="m-0 text-center">{`${amount} руб.`}</p>
        </div>
      </div>
    </div>
  );
};

const FinanceList = ({ transactions }) => {
  const [currentList, setCurrentList] = useState(1);
  const [itemsInList, setItemsInList] = useState(10);

  const indexOfLastItem = currentList * itemsInList;
  const indexOfFirstItem = indexOfLastItem - itemsInList;
  const currentTransactions = transactions.slice(
    indexOfFirstItem,
    indexOfLastItem
  );
  const numOfMaxList = Math.ceil(transactions.length / itemsInList);

  return (
    <div className="col-sm-10 col-md-8 mx-auto">
      <h2 className="text-center">История транзакций</h2>
      <SwitchAnimation keyAnimation={currentList + itemsInList}>
        <div className={cn(styles.financeListWrapper, "col-12")}>
          {currentTransactions.map((item, index) => {
            return <FinanceItem key={index} data={item} />;
          })}
        </div>
      </SwitchAnimation>
      <div className="d-flex mt-2">
        <div className="w-100"></div>
        <Pagination className="w-100 m-0 justify-content-center">
          <Pagination.Prev
            disabled={currentList === 1}
            onClick={() => setCurrentList((prev) => prev - 1)}
          />
          <Pagination.Next
            className="ml-4"
            disabled={currentList === numOfMaxList}
            onClick={() => setCurrentList((prev) => prev + 1)}
          />
        </Pagination>
        <Pagination className="w-100 m-0 mr-2 justify-content-end" size="sm">
          <Pagination.Item
            active={itemsInList === 5}
            onClick={() => {
              setItemsInList(5);
              setCurrentList(1);
            }}
          >
            5
          </Pagination.Item>
          <Pagination.Item
            active={itemsInList === 10}
            onClick={() => {
              setItemsInList(10);
              setCurrentList(1);
            }}
          >
            10
          </Pagination.Item>
          <Pagination.Item
            active={itemsInList === 25}
            onClick={() => {
              setItemsInList(25);
              setCurrentList(1);
            }}
          >
            25
          </Pagination.Item>
        </Pagination>
      </div>
    </div>
  );
};

const CabinetIpay = ({ user, email, prediction }) => {
  const { name, tel, code } = user;
  const [inputChecked, setInputChecked] = useState(false);
  const [localAmount, setLocalAmount] = useState(prediction);
  const [showModal, setShowModal] = useState(false);
  const [error, setError] = useState({
    status: false,
    message: "",
  });
  const [loading, setLoading] = useState(false);

  const handleSubmit = (e) => {
    setLoading(true);
    e.preventDefault();
    let description = `${name}, ${tel}, ${email}, ${code}`;
    const amount = localAmount;

    if (description.length >= 128) {
      description = description.slice(0, 128);
    }

    new FetchService({ amount, description, full_name: name, email })
      .getPayment()
      .then(({ data }) => {
        window.location.href = data.confirmation["confirmation_url"];
      })
      .catch((err) => {
        setError({
          status: true,
          message: err[0],
        });
      })
      .finally(() => {
        setLoading(false);
      });
  };

  return (
    <div className="col-sm-10 col-md-4 mx-auto mt-3 mt-md-0 text-center">
      <h2>Оплата</h2>
      <h3>
        Оплатить занятия можно по реквизитам или по безналичному расчету, через
        наш сайт.
      </h3>
      <form className="form-horizontal" onSubmit={handleSubmit}>
        <div className="form-group row align-items-center">
          <label className="col-lg-3 col-form-label font-weight-bold">
            Сумма оплаты
          </label>
          <div className="col-lg-9">
            <div className="input-group">
              <input
                className="form-control text-right"
                placeholder="Введите сумму  "
                required
                min="1"
                type="number"
                value={localAmount}
                onChange={(e) => setLocalAmount(Number(e.target.value))}
              />
              <div className="input-group-append">
                <div className="input-group-text">
                  <i className="fa fa-ruble"></i>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="form-group row justify-content-center align-items-center">
          <label
            htmlFor="checkboxAgree"
            className={cn(
              styles.lablePaymentModal,
              "col-lg-7 col-form-label font-weight-bold"
            )}
            onClick={() => setShowModal(true)}
          >
            Я ознакомлен с Условиями предоставления услуги.
          </label>
          <input
            type="checkbox"
            id="checkboxAgree"
            checked={inputChecked}
            onChange={(e) => setInputChecked(e.target.checked)}
          />
        </div>
        <div className="form-group row justify-content-center align-items-center">
          <button
            className="btn btn-primary"
            disabled={!inputChecked || !localAmount || loading}
            type="submit"
          >
            {!!loading && (
              <span
                className={cn(
                  styles.spinner,
                  "spinner-border spinner-border-sm mr-2"
                )}
                role="status"
                aria-hidden="true"
              ></span>
            )}
            <span>Оплатить</span>
          </button>
        </div>
      </form>
      <ErrorModal error={error} setError={setError} />
      <PaymentModal show={showModal} setShow={setShowModal} />
    </div>
  );
};

const PaymentModal = ({ show, setShow }) => {
  return (
    <Modal show={show} centered onHide={() => setShow(false)}>
      <Modal.Header closeButton>
        <Modal.Title>Условия предоставления услуги</Modal.Title>
      </Modal.Header>
      <Modal.Body className="p-4">
        Если по каким-либо причинам Вы решили отказаться от исполнения договора
        о выполнении работ (оказании услуг), то можете сделать это в
        соответствии с Законом РФ «О защите прав потребителей» от 07.02.1992 №
        2300-1. Потребитель вправе расторгнуть договор о выполнении работы
        (оказании услуги) в любое время, уплатив исполнителю часть цены
        пропорционально части выполненной работы (оказанной услуги) до получения
        извещения о расторжении указанного договора и возместив исполнителю
        расходы, произведенные им до этого момента в целях исполнения договора,
        если они не входят в указанную часть цены работы (услуги).
      </Modal.Body>
      <Modal.Footer>
        <button className="btn btn-primary" onClick={() => setShow(false)}>
          Закрыть
        </button>
      </Modal.Footer>
    </Modal>
  );
};

const ErrorModal = ({ error, setError }) => {
  const { status, message } = error;
  return (
    <Modal
      show={status}
      centered
      onHide={() => setError({ status: false, message: "" })}
    >
      <Modal.Body className="p-4 text-center">
        <h1>Произошла ошибка!</h1>
        <h2>
          {message
            ? message
            : "Попробуйте позже, либо сообщите администраторам"}
        </h2>
      </Modal.Body>
    </Modal>
  );
};

export const CabinetFinance = ({ user, email }) => {
  const { ref, role } = user;
  const [responseData, setResponseData] = useState({
    data: [],
    loading: true,
    error: false,
  });
  const { data, loading, error } = responseData;

  useEffect(() => {
    new FetchService({ ref, role })
      .getPersonFinance()
      .then(({ data }) => {
        setResponseData((prev) => {
          return { ...prev, data };
        });
      })
      .catch(() => {
        setResponseData((prev) => {
          return { ...prev, error: true };
        });
      })
      .finally(() => {
        setResponseData((prev) => {
          return { ...prev, loading: false };
        });
      });
  }, [ref, role]);

  const calculatePrediction = () => {
    const { prediction, balance } = data;
    let locatPrediction;
    if (balance < 0) {
      locatPrediction = Math.abs(balance) + prediction;
    } else {
      locatPrediction = prediction;
    }
    return locatPrediction;
  };

  return (
    <FetchComponent
      keyAnimation={loading}
      loading={loading}
      error={error}
      heightContainer="40vh"
    >
      {data && (
        <>
          <div className={styles.balanceBlock}>
            <h1 className="text-center m-0">Баланс: {data.balance} руб.</h1>
            {role === "Ученик" && (
              <h2 className="text-center mt-2">
                Рекомендуемый платеж на текущий месяц: {calculatePrediction()}{" "}
                руб.
              </h2>
            )}
          </div>
          <div className="row">
            <FinanceList transactions={data.transactions} />
            {role === "Ученик" && (
              <CabinetIpay
                user={user}
                email={email}
                prediction={calculatePrediction}
              />
            )}
          </div>
        </>
      )}
    </FetchComponent>
  );
};
